module.exports = __webpack_public_path__ + "Flaticon.083bf2781ae39384d78c.woff";


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/fonts/Flaticon.woff
// module id = ../../../../../src/fonts/Flaticon.woff
// module chunks = styles